export default {
  strict: true,
  namespaced: true,
  state: {
    homePageTracked: false,
    opoliCNS: {
      pickupType: '',
      extraStopType: '',
      dropoffType: '',
      getTotal: '',
      getTotal2: ''
    }
  },
  mutations: {
    setHomePageTracked (state, value) {
      state.homePageTracked = value
    },
    setOpoliCnsData (state, data) {
      for (let field in data) {
        state.opoliCNS[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/tracking/index.js